window.__collectionATCLoaded = true;

(function () {
  function addToCart(form) {
    var formData = new FormData(form);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function handle(form, e) {
    // frena navegación del card
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var btn = form.querySelector('button[type="submit"]');
    if (btn && btn.disabled) return;
    if (btn) btn.disabled = true;

   addToCart(form)
  .then(function () {
    window.location.href = '/cart';
  })
      .catch(function (err) {
        console.error('Error al agregar al carrito:', err);
        alert('No se pudo agregar al carrito. Intenta de nuevo.');
      })
      .finally(function () {
        if (btn) btn.disabled = false;
      });
  }
document.addEventListener('pointerdown', function(e){
  var btn = e.target && e.target.closest ? e.target.closest('form.js-collection-atc button[type="submit"]') : null;
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  if (e.stopImmediatePropagation) e.stopImmediatePropagation();
}, true);

  // CAPTURE: se ejecuta antes que los clicks del tema
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('form.js-collection-atc button[type="submit"]') : null;
    if (!btn) return;
    var form = btn.closest('form.js-collection-atc');
    if (!form) return;
    handle(form, e);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('js-collection-atc')) return;
    handle(form, e);
  }, true);
})();
